import {
  Container,
  Paper,
  Theme,
  makeStyles,
  useMediaQuery,
  useTheme,
  ThemeProvider,
} from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import { light } from 'styles/theme.js';
import { Copyright, LoginForm, Logo } from '../components';

interface StyleProps {
  isMobile: boolean;
}

const useStyles = makeStyles<Theme, StyleProps>(theme => ({
  root: {
    display: 'flex',
    width: '100vw',
    height: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
    padding: ({ isMobile }) => (isMobile ? 0 : '0 24px'),
  },
  content: {
    width: ({ isMobile }) => (isMobile ? '100vh' : '100%'),
    height: ({ isMobile }) => (isMobile ? '100vh' : 480),
    marginTop: theme.breakpoints.up('sm') ? 0 : theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 15,
    borderRadius: ({ isMobile }) => (isMobile ? 0 : '1rem'),
  },
}));

export const Login = (): JSX.Element => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles({ isMobile });

  return (
    <ThemeProvider theme={light}>
      <Paper>
        <Container component="main" maxWidth="xs" className={classes.root}>
          <Paper className={classes.content}>
            <Logo />
            <LoginForm onSuccess={() => navigate('/map')} />
            <Copyright />
          </Paper>
        </Container>
      </Paper>
    </ThemeProvider>
  );
};
